export default (chartData) => {
  let activeUsersLabels = [];
  let activeUsersData = [];
  chartData.active_users.results.map((au) => {
    activeUsersLabels.push(au.date);
    activeUsersData.push(au.users);
  });

  // Initialize a Line chart in the container with the ID chart1
  new Chartist.Bar(
    "#chart1",
    {
      labels: activeUsersLabels,
      series: [chartData.active_users.control, activeUsersData],
    },
    {
      stackBars: true,
      axisY: {
        onlyInteger: true,
        offset: 20,
      },
    }
  ).on("draw", function (data) {
    if (data.type === "bar") {
      data.element.attr({
        style: "stroke-width: 30px",
      });
    }
  });

  let weeklyUsersLabels = [];
  let weeklyUsersData = [];
  chartData.weekly_users.map((wu) => {
    weeklyUsersLabels.push(wu.date);
    weeklyUsersData.push(wu.users);
  });
  // Initialize a Line chart in the container with the ID chart2
  new Chartist.Line(
    "#chart2",
    {
      labels: weeklyUsersLabels,
      series: [weeklyUsersData],
    },
    {
      axisY: {
        onlyInteger: true,
        offset: 20,
      },
      low: 0,
      showArea: true,
    }
  );

  // Initialize a Line chart in the container with the ID chart1
  new Chartist.Pie(
    "#chart3",
    {
      series: [
        {
          value: chartData.unconfirmed.results,
          name: "Unconfirmed",
          meta: "Meta One",
        },
        {
          value: chartData.unconfirmed.control,
          name: "Total users",
          meta: "Meta Two",
        },
      ],
    },
    {
      donut: true,
      donutWidth: 60,
      startAngle: 270,
      total: chartData.unconfirmed.results + chartData.unconfirmed.control,
      showLabel: true,
    }
  );

  // Initialize a Line chart in the container with the ID chart2
  new Chartist.Line("#chart4", {
    labels: [1, 2, 3, 4],
    series: [[5, 2, 8, 3]],
  });
};
